var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"headline primary--text"},[(_vm.value)?_c('markdown',{attrs:{"source":_vm.value}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }